import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MetricScoresService {

  private metricScoresSource = new BehaviorSubject<MetricScoreGroup[]>(null);
  currentMetricScores = this.metricScoresSource.asObservable();

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient) { }

  generateScores(rankingId: number) {
    this.http.post(`${this.baseUrl}api/MetricScores/CreateNewRankingScoreSet/${rankingId}`, {}, {observe: 'response'}).subscribe(response => {
      let body: MetricScoreGroup[] = response.body as MetricScoreGroup[];
      this.changeMetricScores(body);
    });
  }

    putScores(metricScores: MetricScore[]) {
      this.http.put(`${this.baseUrl}api/MetricScores/UpdateMetricScoresList/`, metricScores, {observe: 'response'}).subscribe(response => {
      let body: MetricScoreGroup[] = response.body as MetricScoreGroup[];
      this.changeMetricScores(body);
    });
  }

  changeMetricScores(metricScoreGroup: MetricScoreGroup[]) {
    this.metricScoresSource.next(metricScoreGroup);
  }
}

export interface MetricScoreGroup {
  metricScoreId: number,
  rankingId: number,
  rankingStatusName: string,
  projectFacilityName: string,
  appropriatorName: string,
  pointOfDiversionName: string,
  diversionRequestCFS: number,
  metricScoresList: MetricScore[],
  totalWeightedScore: number,
  rank?: null
}

export interface MetricScore {
  rankingId?: number,
  rankingStatusName: string,
  metricScoreId?: number,
  projectFacilityAnnualOperatingPlanId?: number,
  metricRankingId?: number,
  metricId?: number,
  metricName?: string,
  metricEnabled?: boolean,
  metricRankingWeight?: number,
  score?: number,
  scoreWeighted?: number
}

 export interface MetricScorePut {
   metricScoreId: number,
   rankingId: number,
   rankingStatusName: string,
   score?: number
 }

// api/MetricRankings/UpdateMetricRankingList
